import { FormControl, FormGroup } from '@angular/forms';
import { CODCollectedCleared } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`COD Collected/Cleared`,
  FROM_LABEL: $localize`From`,
  TO_LABEL: $localize`To`,
  DATE_LABEL: $localize`Date`,
};

export const FILE_NAME = 'COD-Collected-Report';

export const PDF_REPORT = {
  NAME: 'COD Collected/Cleared',
  HEADER: {
    LOCATION: 'Location:',
    TURN_IN: 'Turn In:',
  },
  FOOTER: {
    TOTAL_EXPECTED: 'Total Expected:',
    TURNED_IN: 'Total Turned In:',
  },
  COLUMNS: [
    'Driver'.toUpperCase(),
    'Loop'.toUpperCase(),
    'Trackno'.toUpperCase(),
    'Customer'.toUpperCase(),
    'City'.toUpperCase(),
    'Expected'.toUpperCase(),
    'CA/CH/C',
    'D/P',
    'TurnedIn'.toUpperCase(),
    'Comments'.toUpperCase(),
    'Collected/Cleared Date'.toUpperCase(),
    'Delivery Date'.toUpperCase(),
    'LocationCode'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'driver',
    'loop',
    'trackno',
    'customer',
    'city',
    'expected',
    'ca/ch/cc',
    'd/p',
    'turnedin',
    'comments',
    'codturnindate',
    'date',
    'locationcode',
  ] as (keyof CODCollectedCleared)[],
};

type CollectedReportField = {
  fromDate: FormControl<Date>;
  toDate: FormControl<Date>;
  reportFormat: FormControl<Options>;
};

export type CollectedReportFormGroup = FormGroup<CollectedReportField> | null;
